import script from "./EstimateUpdatePhaseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EstimateUpdatePhaseModal.vue?vue&type=script&setup=true&lang=js"

import "./EstimateUpdatePhaseModal.vue?vue&type=style&index=0&id=0c06e44e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c06e44e"]])

export default __exports__